import { render, staticRenderFns } from "./DealCard.vue?vue&type=template&id=4fe5b32f&scoped=true&"
import script from "./DealCard.vue?vue&type=script&lang=ts&"
export * from "./DealCard.vue?vue&type=script&lang=ts&"
import style0 from "./DealCard.vue?vue&type=style&index=0&id=4fe5b32f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe5b32f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe5b32f')) {
      api.createRecord('4fe5b32f', component.options)
    } else {
      api.reload('4fe5b32f', component.options)
    }
    module.hot.accept("./DealCard.vue?vue&type=template&id=4fe5b32f&scoped=true&", function () {
      api.rerender('4fe5b32f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/DealCard.vue"
export default component.exports